import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AuthService } from '../../services/auth/auth.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgClass, NgIf } from '@angular/common'; 
import { CommanService } from '../../shared/utils/comman.service';
import { FieldErrorDisplayComponent } from '../../shared/components/field-error-display/field-error-display.component';
import { NotificationService } from '../../shared/utils/notification.service';
import { LoaderService } from '../../services/loader/loader.service';
import { captchaValidator } from '../../shared/utils/captcha.validator';
import { RoleService } from '../../services/role/role.service';
import { LocationService } from '../../shared/utils/location.service';
import { MastersService } from '../../services/cng-sails/masters/masters.service';
import { catchError, forkJoin, of, tap } from 'rxjs';
import { HeaderShowHideService } from '../../shared/utils/headerShowHide.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, FieldErrorDisplayComponent,NgClass, NgIf],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  captchaText!: string;
  captchaImg!: SafeHtml ;
  password: string = '';
  showPassword: boolean = false;
  loaderService = inject(LoaderService);
  loginForm: FormGroup;
  authService = inject(AuthService);
  commonService = inject(CommanService);
  locationService = inject(LocationService);
  notificationService = inject(NotificationService);
  headerService = inject(HeaderShowHideService)
  fb = inject(FormBuilder);
  router = inject(Router);
  roleService = inject(RoleService)
  mastersService = inject(MastersService);
  constructor(private sanitizer: DomSanitizer) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
      //captcha: ['', [Validators.required, captchaValidator(this.captchaText)]],
      captcha: ['', [Validators.required,]],
      location : [],
    });
  }
  ngOnInit() {
    this.refreshCaptcha();
    this.authService.logout();
    this.loaderService.setLoggedInStatus(false);    
    this.headerService.display(false)
  }
   generateCaptcha() {
    // const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // const length = 6; // Length of the CAPTCHA
    // this.captchaText = Array.from({ length }, () =>
    //   characters.charAt(Math.floor(Math.random() * characters.length))
    // ).join('');
     this.authService.getCaptcha().subscribe(res => {
       console.log(res?.image);
       this.captchaImg = this.sanitizer.bypassSecurityTrustHtml(res?.image);
     });
  }
  refreshCaptcha() {
    // this.generateCaptcha();
    // this.loginForm.get('captcha')?.setValidators([
    //   Validators.required,
    //   captchaValidator(this.captchaText),
    // ]);
    // this.loginForm.get('captcha')?.updateValueAndValidity();
    this.authService.getCaptcha().subscribe(res => {
      console.log(res?.image);
      this.captchaImg = this.sanitizer.bypassSecurityTrustHtml(res?.image);
    });
  }
  /*
  *   function name: isFieldValid()
  *   functionality: To check if all the form fields are valid  
  *   parameters : field
  */
  public isFieldValid(field: string) {
    let result = this.commonService.isFormFieldValid(field, this.loginForm);
    return result;
  }

  public doLogin() {
    this.authService.logout();
    this.loaderService.setLoggedInStatus(false);
    if (this.loginForm.valid) {

      const coords = this.locationService.geolocation_coords;
      if (coords != undefined) {
        this.loginForm.get('location')?.patchValue(coords);
      }

      let formData = { ...this.loginForm.value, device_type : 'web' };
      //delete formData.captcha;
      formData.password = this.commonService.encrypt(formData.password);
      this.authService.login(formData).subscribe(data => {
        let resData = <any>data;
        if (resData.code == 200) {
          localStorage.setItem("access_to", resData.data.access_to);
          localStorage.setItem("user_id", resData.data.user_id);
          const rolesJson = JSON.parse(resData.data.roles);
          this.loadData();
          this.roleService.setPermissions(rolesJson['CNG SELLS']);
          this.notificationService.notification('success', resData.message, null, "");
          if (this.authService.isLoggedIn()) {
            this.loaderService.setLoggedInStatus(true);
            this.router.navigate(['/welcome']);
          }
        }
        else {
          this.notificationService.notification('danger', resData.message, null, "");
          if (resData.refreshCaptcha) {
            this.refreshCaptcha();
          }
          this.loaderService.setLoggedInStatus(false);
        }
      });
    } else {
      this.commonService.validateAllFormFields(this.loginForm,"Validation Error");
    }
  }

 public togglePasswordVisibility(): void {
  this.showPassword = !this.showPassword;
}
   
 public loadData(): void {
  localStorage.removeItem('cng_plant');
  localStorage.removeItem('cng_ga');
  forkJoin({
    plantCode: this.authService.plantCodewithName(),
    gaData: this.mastersService.getGA()
  }).pipe(
    tap(({ plantCode, gaData }) => {
      this.handlePlantCodeResponse(plantCode);
      this.handleGAResponse(gaData);
    }),
    catchError(error => {
      console.error("Error loading data:", error);
      // this.notificationService.notification('danger', 'Error loading data. Please try again.', null, "");
      return of(null);
    })
  ).subscribe();
}
  private handlePlantCodeResponse(resData: any): void {
    if (resData?.code === 200) {
      // this.notificationService.notification('success', resData.message, null, "");
    } else {
      // this.notificationService.notification('danger', resData?.message || 'An error occurred.', null, "");
    }
  }

  private handleGAResponse(resData: any): void {
    if (resData?.code === 200) {
      const result: { [key: string]: string } = {};
      resData?.data.forEach((station: { ga_code: string | number; name_of_ga: string; }) => {
        result[station.ga_code] = station.name_of_ga;
        localStorage.setItem('cng_ga', JSON.stringify(result));
      });
      // this.notificationService.notification('success', resData.message, null, "");
    } else {
      // this.notificationService.notification('danger', resData?.message || 'An error occurred.', null, "");
    }
  }
}
  